//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layout from '~/mixins/layout'

export default {
  mixins: [layout],
  data() {
    return {
      showPopup: false,
    }
  },
  mounted() {
    this.checkPopupDate()
  },
  methods: {
    handleDownload() {
      this.handleAction()
      this.closePopupForToday()
    },
    handleClose() {
      this.closePopupForToday()
    },
    handleAction() {
      this.$store.commit('global/setDialog', {
        dialog: 'hearingdiary',
        layer: true,
      })
    },
    resetPopup() {
      this.showPopup = true
    },
    checkPopupDate() {
      const today = new Date().toISOString().split('T')[0]
      const lastShown = localStorage.getItem('popupLastShown')

      if (lastShown !== today) {
        this.showPopup = true
      }
    },
    closePopupForToday() {
      const today = new Date().toISOString().split('T')[0]
      localStorage.setItem('popupLastShown', today)
      this.showPopup = false
    },
  },
}
